import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center px-4 text-center">
      <XCircle size={48} className="text-[#6B7280]" />
      <h1 className="mt-6 font-heading text-2xl font-bold text-[#1F2937]">Checkout canceled</h1>
      <p className="mt-2 font-body text-[#6B7280]">No worries — you can upgrade whenever you're ready.</p>
      <div className="mt-8 flex gap-3">
        <button onClick={() => navigate("/pricing")} data-testid="cancel-pricing" className="rounded-full bg-[#0D9488] px-6 py-3 font-heading font-bold text-white hover:bg-[#0B7F74]">Back to pricing</button>
        <button onClick={() => navigate("/")} data-testid="cancel-home" className="rounded-full border border-[#E5DECF] bg-white px-6 py-3 font-heading font-bold text-[#1F2937] hover:bg-[#F2ECE1]">Go home</button>
      </div>
    </div>
  );
}
